import React, { Component } from 'react'
import { connect } from 'react-redux'
import './styles.css'

import PageWrapper from '../../components/PageWrapper'
import WhiteBox from '../../components/WhiteBox'
import ReactTooltip from 'react-tooltip'
import Sidebar from 'react-sidebar'
import DocDrawer from './drawer'

class Documentation extends Component {
    state = {
        phase: 0,
        userAttributes: null,
        errorMessage: null,
        username: null,
        cognitoUser: null,
        disabled: true,
        changePasswordDisabled: true
    }

    render() {
        const sidebar = <DocDrawer />

        const sidebarProps = {
            sidebar: sidebar,
            docked: true,
            open: true,
            onSetOpen: null
        }

        let marginTopParagraph = '40px'

        return (
            <Sidebar {...sidebarProps}>
                <div className="">
                    <div className="doc-page" style={{ 'margin-bottom': '100px', 'text-align': 'left', padding: '20px', background: '#f1f2f7' }}>
                        <WhiteBox>
                            <div className="row" id="doc_home">
                                <div className="col">
                                    <h2 style={{ 'border-bottom': '1px solid lightgray', 'margin-bottom': '20px' }} className="">
                                        Product Overview
                                    </h2>
                                    <p>
                                        Audiencerate's enables your application customers to distribute anonymously personally identifiable information-based
                                        and device-based segment data (like DSPs, SSPs, and publishers) to popular marketing platforms entirely through the
                                        integrated Dashboard UI or by using the Audiencerate API directly creating custom applications. This enables you to
                                        leverage Audiencerate's identity graph and partnership network of Ad Tech platforms, eliminating the time and resources
                                        required to build and maintain integrations.
                                    </p>

                                    <h3 style={{ marginTop: marginTopParagraph }} className="">
                                        Benefits
                                    </h3>
                                    <p>
                                        Audiencerate platform has those benefits from other competitors:
                                        <ul>
                                            <li>
                                                Audience uploads in <b>1-3 days</b> (not 3 weeks)
                                            </li>
                                            <li>
                                                <b>Revenue Reporting</b> updated every 8 hours 3 times a day, so you can understand revenues, pace of revenues
                                                and yield
                                            </li>
                                            <li>
                                                <b>Direct access to all of Google’s universe</b>
                                            </li>
                                            <li>
                                                Audience size count from <b>today to 30 days before</b> updated every day.
                                            </li>
                                            <li>
                                                <b>Controls</b> over pricing, distribution, segment start/expiration
                                            </li>
                                            <li>
                                                <b>Higher margins</b> form competitors
                                            </li>
                                            <li>
                                                <b>No monthly minimums</b>
                                            </li>
                                            <li>
                                                <b>Reseller program</b> features
                                            </li>
                                            <li>
                                                <b>International Market</b>: we can sell in all the world!
                                            </li>
                                        </ul>
                                    </p>

                                    <h3 style={{ marginTop: marginTopParagraph }} className="">
                                        Workflow
                                    </h3>
                                    <p>
                                        Audiencerate connects your customer data segment with ad tech platforms. After your customer selects a consumer data
                                        segment in the Audiencerate Dashboard UI to distribute to a platform via Audiencerate, Audiencerate anonymizes the data,
                                        matches the anonymized data to the platform's devices, and then delivers the resulting devices to the platform. All the
                                        actions on the Dashboard are viable using an <a href="https://apidocs.audiencerate.com/">API</a>, so its possible to
                                        build custom application that fits your needs.
                                    </p>

                                    <p>
                                        At a high-level, this workflow has the following steps:
                                        <ol>
                                            <li>
                                                Customer provides Audiencerate with a file of consumer data or match users using an UUID Mapping on customer
                                                websites
                                            </li>
                                            <li>
                                                Audiencerate anonymizes the data and organizes it into segments (generally represented by segment data columns
                                                in the file)
                                            </li>
                                            <li>
                                                Customer directs Audiencerate to send a subset (or all) of these segments to an available marketing platform
                                            </li>
                                            <li>
                                                Audiencerate matches the anonymized data to the platform's devices and then delivers the resulting devices to
                                                the platform
                                            </li>
                                            <li>
                                                At this point, the client can then use the segments within the platform to run targeted campaigns, perform
                                                analysis, etc.
                                            </li>
                                        </ol>
                                    </p>

                                    <h3 style={{ marginTop: marginTopParagraph }} className="">
                                        Type of Products Licensed
                                    </h3>
                                    <p>
                                        <ul>
                                            <li>
                                                <b>Adform Marketplace</b>: you can license on the adform marketplace in all countries supported by adform.
                                            </li>
                                            <li>
                                                <b>Audiencerate Reseller</b>: is a special license where you can publish your audiences on Audiencerate
                                                marketplace.
                                            </li>
                                            <li>
                                                <b>Open Marketplace</b>: is a <u>global market</u> where we sell on all Google marketplace buyers.
                                            </li>
                                            <li>
                                                <b>Private Buyer</b>: sell through a Seat ID (identifies the buyer) for exampe an agency.
                                                <br />
                                                <i>Products:</i>
                                                <ul>
                                                    <li>
                                                        <b>DV360 Advertiser</b>
                                                    </li>
                                                    <li>
                                                        <b>DV360 Partner</b>
                                                    </li>
                                                    <li>
                                                        <b>DoubleClick for Publishers</b>
                                                    </li>
                                                </ul>
                                            </li>
                                        </ul>

                                       
                                    </p>

                                    <h3 style={{ marginTop: marginTopParagraph }} className="">
                                        Integration Level
                                    </h3>
                                    <p>
                                        There are two types of integrations:
                                        <ul>
                                            <li>
                                                <b>UUID Mapping</b>, where you place a pixel on your website and allows Audiencerate to map your users using a
                                                cookie. Track all your Properties with a single line of code. Just copy/paste.
                                            </li>
                                            <li>
                                                Integrate by file upload of <b>mobile (such as AAID for Android and IDFA for iOS devices)</b> or <b>adform</b>{' '}
                                                ids.
                                            </li>
                                        </ul>
                                        See <a href="/doc/integrations">Integration Levels</a> section for more details.
                                    </p>

                                    <h3 style={{ marginTop: marginTopParagraph }} className="">
                                        Anonymization and Audience Creation
                                    </h3>
                                    <p>
                                        Every time you send Audiencerate a file, it will automatically be anonymized, segmented, and stored within Audiencerate.
                                        We store no PII within the Audiencerate system itself, and automatically delete all input files within 30 days.
                                        <br />
                                        Once the file has gone through this ingestion process, its segments will show up in in Audiencerate Dashboard UI and be
                                        available to distribute to a destination.
                                    </p>

                                    <h3 style={{ marginTop: marginTopParagraph }} className="">
                                        Licensing and Segments Delivery
                                    </h3>
                                    <p>
                                        License on Google and Doubleclick. We are one of the very few Google 3rd Party Data Provider. Access the widest,
                                        cross-device inventory available.
                                    </p>

                                    <h3 style={{ marginTop: marginTopParagraph }} className="">
                                        Getting Started
                                    </h3>
                                    <p>
                                        Contact your Audiencerate representative to go over the destination platforms you want to make available for your
                                        customers. Once all of the agreements are in place, Audiencerate will provide you with a personal account for accessing
                                        the dashboard and your own API key credentials so that you can start building the integration with the API.
                                    </p>
                                </div>
                            </div>
                        </WhiteBox>
                    </div>
                </div>
            </Sidebar>
        )
    }
}

export default connect(
    state => ({}),
    {}
)(Documentation)
